import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const principlesManifest: FeatureManifest = {
  id: 'english-language-principles',
  path: 'english-knowledge/principles/*',
  navPath: '/english-knowledge/principles',
  label: 'Nguyên lý',
  description: 'Nguyên lý phát triển và đánh giá năng lực',
  navigationGroup: { id: 'english-skills', label: 'Tiêu chuẩn' },
  load: () => import('./entry'),
}
